import type { FormInstance } from "antd";
import { useEffect } from "react";
import dayjs from "dayjs";
import { useUserFormFieldsQuery } from "@/hooks/services";
import type { PurchaseContractFormValues } from "../type";
import { useModal } from "@/hooks/modals/useModal";

export function useInitFormValues(
  form: FormInstance<PurchaseContractFormValues>,
) {
  const userInfo = useUserFormFieldsQuery();
  const { open } = useModal("PURCHASE_CONTRACT");

  useEffect(() => {
    if (!open) return;

    if (userInfo) {
      form.setFieldsValue({
        username: userInfo.nickname,
        employeeCode: userInfo.username,
        createDate: dayjs().format("YYYY-MM-DD"),
        department: userInfo.deptName,
        postName: userInfo.postName,
        email: userInfo.email,
      });
    }
    console.log({ values: form.getFieldsValue() });
  }, [form, userInfo, open]);
}
